/* Brunelia : page « Ma sélection » = « Votre mur ». S'appuie sur window.RV (rv-core.js : RV.sel, RV.cart, RV.copy)
   et sur le moteur de « Composer mon mur » (RV.wall, rv-composer.js : formats en cm, lecture produit, canapé dessiné).
   Lectures : /products/<identifiant>.js pour les seules affiches gardées, puis 1 appel de recommandations en bas de page. */
(function () {
  "use strict";
  var root = document.querySelector("[data-rv-selpage]");
  if (!root) return;
  function ready(fn) {
    if (window.RV && RV.sel && RV.wall) return fn();
    var t = setInterval(function () { if (window.RV && RV.sel && RV.wall) { clearInterval(t); fn(); } }, 30);
  }

  ready(function () {
    var W = RV.wall, ORDER = W.ORDER, esc = RV.esc;
    var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var q = new URLSearchParams(location.search);
    var received = q.get("s") ? RV.sel.parse(q.get("s")).slice(0, 50) : null;
    var data = {}, busy = false, MAXWALL = 12;
    var packs = (root.getAttribute("data-packs") || "").split(",").map(Number).filter(function (x) { return x > 0; });
    /* free shipping threshold of the visitor's zone; 0 = unknown in the visitor's currency (snippet rv-ship-zone): static line, no bar */
    var free = RV.freeShipping != null ? RV.freeShipping : 5900, freeTxt = function () { return free ? RV.moneyShort(free) : RV.freeShippingTxt; };

    function list() { return received || RV.sel.list(); }
    function short(t) { t = String(t || "").replace(/^Affiche\s+/i, ""); return t.charAt(0).toUpperCase() + t.slice(1); }
    function fmt(x) { var d = data[x.h]; return d ? W.bestFmt(d, x.f || "A4") : x.f; }
    function plural(n, w) { return RV.plural(n, w); }
    function many(n) { return RV.lang && RV.lang !== "fr" ? n !== 1 : n > 1; }
    /* affiches lisibles (produit relu) avec leur format retenu */
    function rows() { return list().map(function (x) { var d = data[x.h]; return d ? { x: x, d: d, f: fmt(x) } : null; }).filter(Boolean); }
    function total(rs) { return rs.reduce(function (s, r) { return s + W.price(r.d, r.f); }, 0); }

    /* ---------- le mur à l'échelle (cm → px, un seul facteur pour le canapé et les affiches) ----------
       Repère du mur en cm : x = centre de l'affiche depuis le milieu du mur, y = centre depuis le sol dessiné.
       Dispositions prêtes (grille, alignées, salon, autour d'une grande) ou placement libre (glisser au doigt ou
       à la souris, flèches du clavier), gardé dans le navigateur (rv-sel-disp). Déplacer ne change jamais l'échelle. */
    var SOFA = 220, SOFA_H = 85, ABOVE = 22, GAP = 7, SGAP = 5, DKEY = "rv-sel-disp", LAYS = ["grille", "ligne", "salon", "centre"];
    var TX = {}; try { TX = JSON.parse(($("[data-rv-seltxt]") || {}).textContent || "{}"); } catch (er) {}
    function tx(k, o) { return String(TX[k] || "").replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, n) { return o && o[n] != null ? o[n] : ""; }); }
    function disp() { var d = received ? recvDisp : RV.store.get(DKEY, null); return d && (LAYS.indexOf(d.m) > -1 || d.m === "libre") ? d : { m: "grille", p: {} }; }
    var recvDisp = null;
    function saveDisp(d) {
      if (received) { recvDisp = d; return; }
      var keep = {}; list().forEach(function (x) { if (d.p && d.p[x.h]) keep[x.h] = d.p[x.h]; });
      RV.store.set(DKEY, { m: d.m, p: keep });
    }
    /* dispositions : liste d'éléments { w, h } en cm → centres [x, y], le bas de l'ensemble posé sur « base » */
    function stack(col, gap) { return col.reduce(function (s, it) { return s + it.h; }, 0) + gap * (col.length - 1); }
    function columns(cols, gap, base, stagger) {        /* colonnes côte à côte, empilées, centrées sur un même axe */
      var ws = cols.map(function (c) { return Math.max.apply(null, c.map(function (it) { return it.w; })); });
      var hs = cols.map(function (c) { return stack(c, gap); });
      var off = cols.map(function (c, i) { return stagger && cols.length > 1 ? (i % 2 ? -1 : 1) * stagger : 0; });
      var maxH = Math.max.apply(null, hs.map(function (h, i) { return h + 2 * Math.abs(off[i]); }));
      var axis = base + maxH / 2, x = -(ws.reduce(function (s, w) { return s + w; }, 0) + gap * (cols.length - 1)) / 2, out = [];
      cols.forEach(function (c, i) {
        var top = axis + off[i] + hs[i] / 2;
        c.forEach(function (it) { out.push([it, x + ws[i] / 2, top - it.h / 2]); top -= it.h + gap; });
        x += ws[i] + gap;
      });
      return out;
    }
    var LAYOUT = {
      grille: function (items, base) {
        var n = items.length, nrows = n <= 3 ? 1 : n <= 8 ? 2 : 3, per = Math.ceil(n / nrows), lines = [], out = [];
        for (var i = 0; i < n; i += per) lines.push(items.slice(i, i + per));
        var rowH = lines.map(function (l) { return Math.max.apply(null, l.map(function (it) { return it.h; })); });
        var top = base + rowH.reduce(function (s, h) { return s + h; }, 0) + GAP * (lines.length - 1);
        lines.forEach(function (l, li) {
          var rw = l.reduce(function (s, it) { return s + it.w; }, 0) + GAP * (l.length - 1), x = -rw / 2, bottomAl = lines.length === 1 || li === 0;
          l.forEach(function (it) { out.push([it, x + it.w / 2, bottomAl ? top - rowH[li] + it.h / 2 : top - it.h / 2]); x += it.w + GAP; });
          top -= rowH[li] + GAP;
        });
        return out;
      },
      ligne: function (items, base) { return columns(items.map(function (it) { return [it]; }), GAP, base, 0); },
      salon: function (items, base) {                    /* colonnes de 1 et 2 affiches, décalées en hauteur, serrées */
        var cols = [], i = 0, two = items.length > 2;
        while (i < items.length) { var k = two && cols.length % 2 === 1 && i + 1 < items.length ? 2 : 1; cols.push(items.slice(i, i + k)); i += k; }
        return columns(cols, SGAP, base, items.length > 1 ? 5 : 0);
      },
      centre: function (items, base) {                   /* la plus grande au milieu, les autres en colonnes de chaque côté */
        var big = items.reduce(function (b, it) { return it.w * it.h > b.w * b.h ? it : b; }, items[0]);
        var rest = items.filter(function (it) { return it !== big; }), L = [], R = [];
        rest.forEach(function (it, i) { (i % 2 ? L : R).push(it); });
        function side(a) { var cols = []; for (var j = 0; j < a.length; j += 2) cols.push(a.slice(j, j + 2)); return cols; }
        var cols = side(L).reverse().concat([[big]], side(R));
        return columns(cols, SGAP + 2, base, 0);
      }
    };
    function nf(n) { return String(n).replace(".", !RV.lang || RV.lang === "fr" ? "," : "."); }
    function dimTxt(d, f) { var dm = W.dims(d, f); return nf(dm[0]) + " × " + nf(dm[1]); }
    var G = null, drag = null, zTop = 2;
    function sofaSVG() {
      return '<rect class="s2" x="14" y="6" width="192" height="44" rx="11"/>' +
        [22, 82, 142].map(function (x) { return '<rect class="s1" x="' + x + '" y="10" width="56" height="36" rx="9"/>'; }).join("") +
        '<rect class="s2" x="16" y="54" width="188" height="22" rx="5"/>' +
        '<rect class="s3" x="22" y="44" width="86" height="16" rx="7"/><rect class="s3" x="112" y="44" width="86" height="16" rx="7"/>' +
        '<rect class="s1" x="0" y="30" width="26" height="46" rx="11"/><rect class="s1" x="194" y="30" width="26" height="46" rx="11"/>' +
        '<rect class="s4" x="10" y="75" width="6" height="10" rx="1.5"/><rect class="s4" x="204" y="75" width="6" height="10" rx="1.5"/>' +
        '<rect class="s4" x="60" y="75" width="5" height="10" rx="1.5"/><rect class="s4" x="155" y="75" width="5" height="10" rx="1.5"/>';
    }
    function drawWall() {
      var st = $("[data-rv-stage]"), Wp = st.clientWidth; if (!Wp) return;
      var rs = rows(), slots = !list().length, onWall = rs.slice(0, MAXWALL);
      var items = slots ? [{ s: "A3", w: 29.7, h: 42 }, { s: "A2", w: 42, h: 59.4 }, { s: "A3", w: 29.7, h: 42 }] :
        onWall.map(function (r) { var dm = W.dims(r.d, r.f); return { r: r, key: r.x.h, w: dm[0], h: dm[1] }; });
      if (!items.length) return;
      /* téléphone : le canapé entier (pieds compris) et 250 cm de mur au moins, pour que les 220 cm tiennent en largeur */
      var mob = Wp < 600, CUT = mob ? 0 : 30, base = SOFA_H - CUT + ABOVE, R = mob ? 0.95 : 9.4 / 16;
      var d = slots ? { m: "grille", p: {} } : disp(), placed;
      if (d.m === "libre") {
        var known = items.filter(function (it) { return d.p[it.key]; }), fresh = items.filter(function (it) { return !d.p[it.key]; });
        placed = known.map(function (it) { return [it, d.p[it.key][0], d.p[it.key][1]]; });
        if (fresh.length) {                              /* nouvelle affiche en placement libre : posée à droite de l'ensemble */
          var right = placed.reduce(function (m, p) { return Math.max(m, p[1] + p[0].w / 2); }, -GAP);
          var fl = LAYOUT.ligne(fresh, base), left = fl[0][1] - fl[0][0].w / 2;
          fl.forEach(function (p) { placed.push([p[0], p[1] + right + GAP - left, p[2]]); });
        }
      } else placed = LAYOUT[d.m](items, base);
      var ext = placed.reduce(function (m, p) { return Math.max(m, Math.abs(p[1]) + p[0].w / 2); }, 0);
      var top = placed.reduce(function (m, p) { return Math.max(m, p[2] + p[0].h / 2); }, 0);
      /* le mur visible s'élargit (tout rapetisse ensemble) si les affiches ne tiennent pas : l'échelle reste vraie */
      var wallcm = Math.max(mob ? 250 : 280, 2 * ext / 0.9, (top + (mob ? 30 : 14)) / (mob ? 1.3 : R));
      if (slots) wallcm *= 1.2;                          /* cadres vides un peu en retrait : la place du message */
      var Hc = Math.max(wallcm * R, top + (mob ? 30 : 14)), k = Wp / wallcm, g = $("[data-rv-gallery]");
      st.style.aspectRatio = (wallcm / Hc).toFixed(4);
      G = { wallcm: wallcm, Hc: Hc, k: k, d: d, placed: placed };
      g.innerHTML = placed.map(function (p, i) {
        var it = p[0], css = "width:" + (it.w * k).toFixed(1) + "px;height:" + (it.h * k).toFixed(1) + "px;" + posCss(p[1], p[2], it);
        if (it.s) return '<div class="rvs-slot" style="' + css + '">' + it.s + "</div>";
        return '<div class="rvs-p" role="button" tabindex="0" data-i="' + i + '" aria-roledescription="' + esc(tx("drag_role")) + '" aria-label="' + esc(tx("poster_label", { title: short(it.r.d.t), f: it.r.f })) + '" style="' + css + '">' +
          '<img src="' + esc(it.r.d.i) + '" alt="" decoding="async" draggable="false"><small>' + it.r.f + "</small></div>";
      }).join("");
      var sofaW = SOFA * k, x0 = (Wp - sofaW) / 2;
      $("[data-rv-deco]").innerHTML =
        '<svg class="rvs-sofa" viewBox="0 0 220 85" preserveAspectRatio="none" aria-hidden="true" style="left:' + x0 + "px;width:" + sofaW + "px;height:" + SOFA_H * k + "px;bottom:" + (-CUT * k) + 'px">' + sofaSVG() + "</svg>" +
        (x0 + sofaW + 46 * k < Wp ? '<svg class="rvs-plant" viewBox="0 0 46 110" preserveAspectRatio="none" aria-hidden="true" style="left:' + (x0 + sofaW + 6 * k) + "px;width:" + 38 * k + "px;height:" + 90 * k + "px;bottom:" + (-CUT * k) + 'px">' + W.plant + "</svg>" : "");
      var more = rs.length - onWall.length;
      $("[data-rv-scale]").textContent = RV.t("selection_page_js.scale") + (more ? " · " + RV.t("selection_page_js.scale_more", { items: plural(more, "autre_affiche") }) : "");
      st.setAttribute("aria-label", slots ? RV.t("selection_page_js.wall_empty") :
        RV.t("selection_page_js.wall_full", { items: plural(onWall.length, "affiche"), formats: onWall.map(function (r) { return r.f; }).join(", ") }));
      /* au-dessus du mur : les formats affichés ; sous le mur : la disposition */
      var sz = $("[data-rv-sizes]");
      if (sz && onWall.length) {
        var seen = {}, parts = [];
        onWall.forEach(function (r) { var t = r.f + " · " + dimTxt(r.d, r.f) + " cm"; if (!seen[t]) { seen[t] = 1; parts.push(t); } });
        sz.textContent = parts.length === 1 ? tx("sizes_one", { f: onWall[0].f, d: dimTxt(onWall[0].d, onWall[0].f) }) : tx("sizes_many", { list: parts.join(", ") });
      }
      $$("[data-lay]").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-lay") === d.m)); });
      var rz = $("[data-lay-reset]"); if (rz) rz.hidden = d.m === "grille";
      var hint = $("[data-lay-hint]"); if (hint) hint.textContent = tx(d.m === "libre" ? "lay_free" : "drag_hint");
    }
    function posCss(cx, cy, it) { return "left:" + ((G ? G.wallcm : 0) / 2 + cx - it.w / 2) * (G ? G.k : 0) + "px;top:" + ((G ? G.Hc : 0) - cy - it.h / 2) * (G ? G.k : 0) + "px"; }
    /* placement libre : la première affiche déplacée fige toutes les positions affichées, puis chacune bouge seule */
    function toFree() {
      if (G.d.m === "libre") return;
      var p = {}; G.placed.forEach(function (q) { p[q[0].key] = [q[1], q[2]]; });
      G.d = { m: "libre", p: p };
    }
    function moveTo(el, i, cx, cy) {
      var q = G.placed[i], it = q[0], hw = it.w / 2, hh = it.h / 2;
      cx = Math.max(-G.wallcm / 2 + hw + 1, Math.min(G.wallcm / 2 - hw - 1, cx));
      cy = Math.max(hh + 2, Math.min(G.Hc - hh - 2, cy));
      q[1] = cx; q[2] = cy; G.d.p[it.key] = [Math.round(cx * 10) / 10, Math.round(cy * 10) / 10];
      var s = posCss(cx, cy, it).split(";"); el.style.left = s[0].slice(5); el.style.top = s[1].slice(4);
    }
    function endFree() {
      saveDisp(G.d);
      $$("[data-lay]").forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
      var rz = $("[data-lay-reset]"); if (rz) rz.hidden = false;
      var hint = $("[data-lay-hint]"); if (hint) hint.textContent = tx("lay_free");
    }
    var gal = $("[data-rv-gallery]");
    gal.addEventListener("pointerdown", function (e) {
      var el = e.target.closest(".rvs-p"); if (!el || !G || (e.pointerType === "mouse" && e.button !== 0)) return;
      var i = +el.getAttribute("data-i"), q = G.placed[i]; if (!q) return;
      e.preventDefault();
      try { el.setPointerCapture(e.pointerId); } catch (er) {}
      drag = { el: el, i: i, id: e.pointerId, sx: e.clientX, sy: e.clientY, cx: q[1], cy: q[2], moved: false };
    });
    gal.addEventListener("pointermove", function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.sx, dy = e.clientY - drag.sy;
      if (!drag.moved) { if (dx * dx + dy * dy < 16) return; drag.moved = true; toFree(); drag.el.classList.add("is-drag"); drag.el.style.zIndex = ++zTop; }
      moveTo(drag.el, drag.i, drag.cx + dx / G.k, drag.cy - dy / G.k);
    });
    function drop(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d0 = drag; drag = null; d0.el.classList.remove("is-drag");
      if (d0.moved) endFree();
    }
    gal.addEventListener("pointerup", drop); gal.addEventListener("pointercancel", drop);
    gal.addEventListener("dragstart", function (e) { e.preventDefault(); });
    gal.addEventListener("keydown", function (e) {
      var el = e.target.closest(".rvs-p"), dir = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, 1], ArrowDown: [0, -1] }[e.key];
      if (!el || !dir || !G) return;
      e.preventDefault(); toFree();
      var i = +el.getAttribute("data-i"), q = G.placed[i], st = e.shiftKey ? 10 : 2;
      moveTo(el, i, q[1] + dir[0] * st, q[2] + dir[1] * st); endFree();
    });

    /* ---------- liste, total, livraison, pack ---------- */
    function itemHTML(x) {
      var d = data[x.h];
      if (d === undefined) return '<li class="rvs-it is-load" aria-hidden="true"><span class="rvs-it-pic"></span><span></span><span></span></li>';
      if (!d) return "";
      var f = fmt(x), v = d.v[f] || [0, 0, 0], u = d.url + "?taille=" + f, t = short(d.t);
      return '<li class="rvs-it"><a class="rvs-it-pic" href="' + esc(u) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(d.i) + '" alt="" loading="lazy" width="64" height="90"></a>' +
        '<div><a class="rvs-it-t" href="' + esc(u) + '">' + esc(t) + "</a>" +
        '<div class="rvs-fmts" role="group" aria-label="' + RV.t("selection_page_js.format_of", { title: esc(t) }) + '">' + ORDER.filter(function (F) { return d.v[F]; }).map(function (F) {
          return '<button type="button" data-fmt="' + F + '" data-h="' + esc(x.h) + '" aria-pressed="' + (F === f) + '" aria-label="' + F + ", " + RV.money(d.v[F][1]) + '">' + F + "</button>";
        }).join("") + "</div></div>" +
        '<div class="rvs-it-r"><span class="rvs-price num">' + RV.money(v[1]) + "</span>" + (v[2] > v[1] ? '<s class="num">' + RV.money(v[2]) + "</s>" : "") +
        '<button class="rvs-link" type="button" data-rm="' + esc(x.h) + '" aria-label="' + RV.t("selection_page_js.remove_title", { title: esc(t) }) + '">' + RV.t("selection_page_js.remove") + "</button></div></li>";
    }
    function packHTML(n, t) {
      if (!packs.length) return "";
      var p3 = packs[0], p4 = packs[1] || packs[0], pct = n >= 4 ? p4 : n >= 3 ? p3 : 0;
      if (!pct) return RV.t("selection_page_js.pack_hint", { p3: p3, p4: p4, items: plural(3 - n, "affiche") });
      var save = Math.round(t * pct / 100);
      return RV.t("selection_page_js.pack_on", { n: n, pct: pct, save: RV.money(save), after: RV.money(t - save), total: RV.money(t) });
    }
    function summary() {
      var rs = rows(), n = rs.length, t = total(rs), all = list();
      $("[data-rv-count]").textContent = n ? RV.t("selection_page_js.on_wall", { items: plural(n, "affiche") }) : RV.t("selection_page_js.loading");
      $("[data-rv-n]").textContent = plural(n, "affiche");
      $("[data-rv-total]").textContent = RV.money(t);
      $("[data-rv-ship-txt]").innerHTML = !free ? RV.t("ship_js.from", { amount: freeTxt() }) : t >= free ? RV.t("selection_page_js.ship_all_free") : RV.t("selection_page_js.ship_left", { left: RV.money(free - t) });
      $("[data-rv-ship]").classList.toggle("ok", !!free && t >= free);
      $("[data-rv-ship] i").style.width = (free ? Math.min(100, t / free * 100) : 0) + "%";
      var pk = $("[data-rv-pack]"); if (pk) pk.innerHTML = n ? packHTML(n, t) : "";
      $("[data-rv-mn]").textContent = plural(n, "affiche") + " · " + (free && t >= free ? RV.t("selection_page_js.ship_free_short") : RV.t("selection_page_js.ship_from", { amount: freeTxt() }));
      $("[data-rv-mt]").textContent = RV.money(t);
      /* « Tout passer en » : total si chaque affiche passe dans ce format (quand il existe pour elle) */
      $$("[data-all]").forEach(function (b) {
        var F = b.getAttribute("data-all"), any = rs.some(function (r) { return r.d.v[F]; });
        var s = rs.reduce(function (a, r) { return a + W.price(r.d, r.d.v[F] ? F : r.f); }, 0);
        b.disabled = !any;
        b.setAttribute("aria-pressed", String(!!n && any && rs.every(function (r) { return r.f === F || !r.d.v[F]; })));
        b.querySelector("small").textContent = n ? RV.money(s) : " ";
        b.setAttribute("aria-label", RV.t("selection_page_js.all_to", { f: F, total: RV.money(s) }));
      });
      $("[data-rv-card-pics]").innerHTML = rs.slice(0, 4).map(function (r) { return '<img src="' + esc(r.d.i) + '" alt="" loading="lazy">'; }).join("");
      var gone = all.filter(function (x) { return data[x.h] === null; }).length, g = $("[data-rv-gone]");
      g.hidden = !gone; g.textContent = gone ? RV.t(many(gone) ? "selection_page_js.gone_other" : "selection_page_js.gone_one", { items: plural(gone, "affiche") }) : "";
    }
    function render() {
      var all = list(), full = all.length > 0;
      root.classList.toggle("is-full", full); root.classList.toggle("is-empty", !full);
      root.style.setProperty("--n", all.length);
      if (received) {
        $("[data-rv-recv]").hidden = false;
        $("[data-rv-recv-title]").textContent = RV.t("selection_page_js.recv_title", { items: plural(all.length, "affiche") });
        $("[data-rv-sel-clear]").hidden = true;
      }
      if (full) {
        $("[data-rv-items]").innerHTML = all.map(itemHTML).join("");
        summary();
        sugg();
      }
      drawWall();
      sendBox();
    }
    /* « À choisir à 2 » : 4 boutons ronds (snippet rv-sendto), lien de la sélection calculé au clic, message suivant le nombre d'affiches */
    RV.selShareUrl = function () { return RV.sel.shareUrl(shareList()); };
    function sendBox() {
      var box = $("[data-rv-sendto]"); if (!box) return;
      var n = list().length;
      box.setAttribute("data-msg", n > 1 ? RV.t("selection_page_js.msg_many", { n: n }) : RV.t("selection_page_js.msg_one"));
      if (RV.sendRefresh) RV.sendRefresh(box);
    }
    function load() {
      var todo = list().filter(function (x) { return data[x.h] === undefined; });
      render();
      if (!todo.length) return;
      Promise.all(todo.map(function (x) {
        return W.fetchProduct(x.h, 500).then(function (d) { data[x.h] = d; }, function () { data[x.h] = null; });
      })).then(render);
    }

    /* ---------- « Elles iraient bien sur ce mur » : 1 appel de recommandations, seulement en approchant du bas ---------- */
    var suggDone = false;
    function sugg() {
      if (suggDone) return;
      var first = rows()[0]; if (!first || !first.d.id) return;
      suggDone = true;
      var box = $("[data-rv-sugg]"), grid = $("[data-rv-sugg-grid]");
      box.hidden = false;
      grid.innerHTML = new Array(5).join('<div class="rvs-k is-load" aria-hidden="true"><span class="rvs-k-pic"></span></div>');
      var go = function () {
        fetch((RV.root || "/").replace(/\/$/, "") + "/recommendations/products.json?product_id=" + first.d.id + "&limit=10&intent=related")
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var mine = list().map(function (x) { return x.h; });
            var ps = (j.products || []).filter(function (p) { return mine.indexOf(p.handle) < 0 && p.available !== false; }).slice(0, 4);
            if (!ps.length) { box.hidden = true; return; }
            grid.innerHTML = ps.map(function (p) {
              var img = p.featured_image || ""; if (img.indexOf("//") === 0) img = "https:" + img;
              var sep = img.indexOf("?") > -1 ? "&" : "?", t = short(p.title), pr = p.price_min || p.price || 0;
              return '<div class="rvs-k is-poster"><a class="rvs-k-pic" href="' + esc(p.url) + '"><img class="rvs-k-img" src="' + esc(img + sep + "width=500") + '" alt="' + esc(p.title) + '" loading="lazy"></a>' +
                '<button class="fav" type="button" data-rv-heart="' + esc(p.handle) + '" data-rv-format="" data-rv-title="' + esc(p.title) + '" data-rv-img="' + esc(img + sep + "width=300") + '" data-rv-price="' + pr + '" aria-pressed="' + RV.sel.has(p.handle) + '" aria-label="' + RV.t("selection_page_js.keep_title", { title: esc(p.title) }) + '"><svg width="18" height="18" aria-hidden="true"><use href="#i-heart"/></svg></button>' +
                '<a class="rvs-k-t" href="' + esc(p.url) + '">' + esc(t) + '</a><span class="rvs-k-p">' + RV.t("core_js.from_price", { price: '<b class="num">' + RV.money(pr) + "</b>" }) + "</span></div>";
            }).join("");
          })
          .catch(function () { box.hidden = true; });
      };
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); } }, { rootMargin: "600px 0px" });
        io.observe(box);
      } else go();
    }

    /* ---------- actions ---------- */
    function setFormat(h, f) {
      if (received) received.forEach(function (x) { if (x.h === h) x.f = f; });
      else RV.sel.setFormat(h, f);
    }
    function cartItems() { return rows().map(function (r) { var v = r.d.v[r.f]; return v ? { id: v[0], quantity: 1 } : null; }).filter(Boolean); }
    function shareList() { return list().map(function (x) { return { h: x.h, f: fmt(x) }; }); }
    function say(t) { var l = $("[data-rv-live]"); if (l) { l.textContent = ""; setTimeout(function () { l.textContent = t; }, 30); } }

    root.addEventListener("click", function (e) {
      var w = e.target.closest("[data-wall]");
      if (w) {
        var c = w.getAttribute("data-wall");
        $$("[data-wall]").forEach(function (b) { b.setAttribute("aria-pressed", String(b === w)); });
        root.style.setProperty("--wall", c); root.classList.toggle("is-dark", c === "#24364f");
        RV.store.set("rv-sel-mur", c); return;
      }
      var ly = e.target.closest("[data-lay]");
      if (ly) { saveDisp({ m: ly.getAttribute("data-lay"), p: {} }); drawWall(); say(ly.textContent); return; }
      if (e.target.closest("[data-lay-reset]")) { saveDisp({ m: "grille", p: {} }); drawWall(); say(tx("lay_reset_done")); var g0 = $("[data-lay=grille]"); if (g0) g0.focus(); return; }
      var a = e.target.closest("[data-all]");
      if (a && !a.disabled) {
        var F = a.getAttribute("data-all"); busy = true;
        rows().forEach(function (r) { if (r.d.v[F]) setFormat(r.x.h, F); });
        busy = false; render(); say(RV.t("selection_page_js.all_done", { f: F, total: $("[data-rv-total]").textContent })); return;
      }
      var f = e.target.closest("[data-fmt]");
      if (f) {
        var fh = f.getAttribute("data-h"), ff = f.getAttribute("data-fmt");
        busy = true; setFormat(fh, ff); busy = false; render();
        $$("[data-fmt]").forEach(function (b) { if (b.getAttribute("data-h") === fh && b.getAttribute("data-fmt") === ff) b.focus(); });
        say(RV.t("selection_page_js.fmt_chosen", { f: ff, total: $("[data-rv-total]").textContent })); return;
      }
      var rm = e.target.closest("[data-rm]");
      if (rm) {
        var h = rm.getAttribute("data-rm"), idx = $$("[data-rm]").indexOf(rm);
        busy = true;
        if (received) received = received.filter(function (x) { return x.h !== h; }); else RV.sel.remove(h);
        busy = false; render(); RV.toast(RV.t("core_js.removed_sel"));
        var rest = $$("[data-rm]"); if (rest.length) rest[Math.min(idx, rest.length - 1)].focus();
        return;
      }
      if (e.target.closest("[data-rv-sel-cart]")) {
        var it = cartItems(), btns = $$("[data-rv-sel-cart]"); if (!it.length) return;
        btns.forEach(function (b) { b.disabled = true; });
        RV.cart.add(it).then(function () { RV.toast(RV.t(many(it.length) ? "core_js.n_added_cart_other" : "core_js.n_added_cart_one", { items: plural(it.length, "affiche") })); }, function () {})
          .then(function () { btns.forEach(function (b) { b.disabled = false; }); });
        return;
      }
      if (e.target.closest("[data-rv-sel-pdf]")) { pdf(); return; }
      var clr = e.target.closest("[data-rv-sel-clear]");
      if (clr) {
        if (!clr.dataset.armed) { clr.dataset.armed = "1"; clr.textContent = RV.t("selection_page_js.clear_confirm"); setTimeout(function () { delete clr.dataset.armed; clr.textContent = RV.t("selection_page_js.clear"); }, 4000); return; }
        delete clr.dataset.armed; clr.textContent = RV.t("selection_page_js.clear"); busy = true; RV.sel.clear(); busy = false; RV.toast(RV.t("selection_page_js.cleared")); render(); return;
      }
      if (e.target.closest("[data-rv-recv-save]")) {
        var add = RV.sel.merge(received.map(function (x) { var d = data[x.h], F = fmt(x); return { h: x.h, f: F, t: d ? d.t : "", i: d ? d.i : "", p: d ? W.price(d, F) : 0 }; }));
        var had = received.length - add;
        RV.toast(RV.t(many(add) ? "core_js.n_added_sel_other" : "core_js.n_added_sel_one", { items: plural(add, "affiche") }) + (had ? RV.t("selection_page_js.already_in", { n: had }) : ""));
        received = null; $("[data-rv-recv]").hidden = true; $("[data-rv-sel-clear]").hidden = false;
        try { history.replaceState(null, "", location.pathname); } catch (er) {}
        load();
      }
    });
    document.addEventListener("rv:selection-change", function () { if (!busy && !received) load(); });

    /* barre fixe du bas (téléphone) : posée juste au-dessus de la barre Accueil, Affiches, Ma sélection, Panier */
    function bbar() { var b = document.querySelector(".bbar"); var h = b && getComputedStyle(b).display !== "none" ? b.offsetHeight : 0; root.style.setProperty("--bbar-h", h + "px"); }
    var rz; window.addEventListener("resize", function () { clearTimeout(rz); rz = setTimeout(function () { bbar(); drawWall(); }, 80); });
    bbar();

    var saved = RV.store.get("rv-sel-mur", null);
    if (saved) $$("[data-wall]").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-wall") === saved)); });

    /* PDF : feuille A4 imprimée par le navigateur (« Enregistrer en PDF »). */
    function pdf() {
      var sheet = document.querySelector("[data-rv-print]"), rs = rows();
      var date = new Date().toLocaleDateString(!RV.lang || RV.lang === "fr" ? "fr-FR" : RV.lang, { day: "numeric", month: "long", year: "numeric" });
      sheet.innerHTML = '<header><img src="' + esc((document.querySelector(".logo img, header img") || {}).src || "") + '" alt="Brunelia"><span>' + RV.t("selection_page_js.print_head", { date: date }) + "</span></header>" +
        '<div class="pdf-items">' + rs.map(function (r) { var u = (RV.shopUrl || location.origin) + r.d.url + "?taille=" + r.f;
          return '<div class="pdf-it"><img src="' + esc(r.d.i) + '" alt=""><div><b>' + esc(r.d.t) + "</b><br>" + esc(r.f) + " · " + RV.money(W.price(r.d, r.f)) + "<br><small>" + esc(u.replace(/^https?:\/\//, "")) + "</small></div></div>"; }).join("") + "</div>" +
        "<footer>" + RV.t("selection_page_js.print_foot", { total: RV.money(total(rs)), amount: free ? RV.money(free) : freeTxt() }) + "</footer>";
      document.documentElement.classList.add("rv-printing");
      var done = function () { document.documentElement.classList.remove("rv-printing"); window.removeEventListener("afterprint", done); };
      window.addEventListener("afterprint", done);
      var imgs = Array.prototype.slice.call(sheet.querySelectorAll("img"));
      Promise.all(imgs.map(function (im) { return im.complete ? 1 : new Promise(function (r) { im.onload = im.onerror = r; }); })).then(function () { window.print(); setTimeout(done, 1500); });
    }

    load();
  });
})();
